import { render, staticRenderFns } from "./ConceptProvider.vue?vue&type=template&id=35068eee&"
import script from "./ConceptProvider.vue?vue&type=script&lang=js&"
export * from "./ConceptProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports